import { render } from "./AuthorizedEmployees.vue?vue&type=template&id=c0b93d66"
import script from "./AuthorizedEmployees.vue?vue&type=script&lang=js"
export * from "./AuthorizedEmployees.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__